import React from 'react'
import { SxProps } from '@mui/system'
import { IconButton } from '@mui/material'
import { J2Editacontent } from '@e3dc-react/icons'
import useModals from 'src/Hooks/useModals'
import { DownloadFileItem, DownloadsCategoryModel } from '../models'

interface Props {
  parent?: DownloadsCategoryModel
  item: DownloadFileItem
  sx?: SxProps
  selectCategory: (categoryId?: number) => void
}

/**
 * Button to edit a download item
 */
const EditDownloadFileButton: React.FC<Props> = ({ item, sx, selectCategory, parent }) => {
  const { openDownloadItemEditor } = useModals()

  return (
    <IconButton sx={sx} onClick={() => openDownloadItemEditor({ item, selectCategory, parent })}>
      <J2Editacontent />
    </IconButton>
  )
}

export default EditDownloadFileButton
